import { Vault, VaultBase } from '@/types';
import {
  GetFiltersType,
  GetSortingType,
  PageableInterface,
} from '@prometheus/types';
import { api, getSortDirection } from '@prometheus/utils';

//---GET LIST------------------------------------------------------------
export const getVaults = (
  searchParams: any
): Promise<PageableInterface<Vault>> => {
  const { pageNumber, pageSize, sortBy, query } = searchParams;
  const sort = getSortDirection(sortBy);

  return api.get(
    `/vaults/list?${query || ''}&size=${pageSize || ''}` +
      `&page=${pageNumber || ''}` +
      `&sort=${sort}`
  );
};

//---CREATE------------------------------------------------------------
export const createVault = (vault: VaultBase): Promise<Vault> =>
  api.post('/vaults', vault);

//---UPDATE------------------------------------------------------------
export const updateVault = (id: string, vault: VaultBase): Promise<Vault> =>
  api.put('/vaults/' + id, vault);

//---FILTER------------------------------------------------------------
export const getVaultFilters: GetFiltersType = options => {
  const url = `/vaults/filter?${options}`;
  return api.get(url);
};

//---SORT--------------------------------------------------------------
export const getVaultSorting: GetSortingType = () => {
  return api.get('/vaults/sorts');
};
